var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg040202(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 161,
    viewBox: "0 0 141 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_04_02_02",
    clipPath: "url(#clip0_228_285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_228_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.537 83.2959L106.717 112.533C106.256 114.063 105.415 115.455 104.269 116.572L85.6268 134.836C82.8143 137.59 78.593 138.327 75.0176 136.68L50.1774 125.28C48.6948 124.6 47.4102 123.55 46.4535 122.231L29.2023 98.4664C28.3579 97.2987 27.7857 95.9579 27.5347 94.5341L19.8243 50.8063C19.0869 46.6244 21.2157 42.4572 25.0429 40.604L57.4873 24.9032C59.0459 24.1478 60.7878 23.8341 62.5149 23.997L99.6469 27.4888C103.905 27.8901 107.371 31.0839 108.114 35.2977L115.803 78.9043C116.061 80.3663 115.971 81.8764 115.543 83.2948L115.537 83.2959Z",
    fill: "#FAB908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8339 137.09L87.8346 137.089L106.471 118.831C106.472 118.83 106.473 118.829 106.474 118.828C108.004 117.335 109.123 115.479 109.737 113.444C109.737 113.444 109.737 113.444 109.737 113.443L118.503 84.3875C118.525 84.3279 118.545 84.2674 118.564 84.2061C119.135 82.3138 119.253 80.3039 118.91 78.3565L111.221 34.7499C110.231 29.1363 105.613 24.8824 99.943 24.348L99.9423 24.3479L62.8111 20.8562C62.8108 20.8562 62.8106 20.8561 62.8103 20.8561C60.5104 20.6394 58.1904 21.0568 56.1114 22.0644L23.6687 37.7643L23.668 37.7646C18.5712 40.2326 15.7351 45.7829 16.7175 51.3541L24.4279 95.0819C24.7628 96.9811 25.5256 98.7657 26.646 100.315L26.6494 100.32L43.8998 124.083C43.9 124.083 43.9003 124.084 43.9005 124.084C45.1773 125.844 46.8889 127.243 48.8616 128.148C48.8618 128.148 48.8621 128.148 48.8623 128.148L73.6975 139.545C73.6982 139.546 73.6989 139.546 73.6997 139.546C78.4671 141.742 84.0898 140.756 87.8339 137.09Z",
    stroke: "white",
    strokeWidth: 6.3094,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_d_228_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4702 33.3485L31.932 46.6701C28.6874 48.2428 26.8745 51.775 27.5004 55.3248L34.0456 92.4447C34.2584 93.6514 34.7423 94.7905 35.4636 95.7824L50.1059 115.952C50.9222 117.072 52.0082 117.966 53.2681 118.541L74.3488 128.22C75.8667 128.914 77.5206 129.109 79.0924 128.839L62.1213 32.5914C61.2035 32.6874 60.3074 32.9442 59.4702 33.3485Z",
    fill: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_d_228_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3544 126.652L99.1787 111.15C100.15 110.202 100.864 109.023 101.254 107.723L108.741 82.9077C109.107 81.6977 109.178 80.4212 108.958 79.1762L102.432 42.1649C101.802 38.5895 98.8613 35.8758 95.247 35.5388L63.7317 32.5773C63.1898 32.528 62.6505 32.5309 62.1213 32.5913L79.0923 128.839C80.6693 128.561 82.1589 127.824 83.3544 126.652Z",
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter3_d_228_285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.9602 67.9726L74.9184 70.2722C73.8943 70.4528 72.912 69.7699 72.7305 68.7402L70.4309 55.6985C70.2503 54.6744 69.2726 53.9849 68.243 54.1665L63.7481 54.9591C62.724 55.1396 62.0346 56.1174 62.2161 57.147L64.5157 70.1887C64.6963 71.2128 64.0133 72.1951 62.9837 72.3766L49.9419 74.6763C48.9179 74.8568 48.2284 75.8345 48.41 76.8642L49.2025 81.359C49.3831 82.3831 50.3608 83.0726 51.3904 82.891L64.4322 80.5914C65.4563 80.4108 66.4386 81.0938 66.6201 82.1234L68.9197 95.1652C69.1003 96.1892 70.078 96.8787 71.1076 96.6971L75.6025 95.9046C76.6266 95.724 77.3161 94.7463 77.1345 93.7167L74.8349 80.6749C74.6543 79.6508 75.3373 78.6685 76.3669 78.487L89.4087 76.1874C90.4327 76.0068 91.1222 75.0291 90.9407 73.9995L90.1481 69.5046C89.9675 68.4805 88.9898 67.7911 87.9602 67.9726Z",
    fill: "#6F97F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5219 65.4872L75.1056 67.6765L72.9163 55.2602C72.4945 52.8683 70.2118 51.2566 67.8047 51.6811L63.3098 52.4736C60.9179 52.8954 59.3062 55.1781 59.7307 57.5852L61.92 70.0015L49.5037 72.1908C47.1118 72.6126 45.5001 74.8953 45.9245 77.3024L46.7171 81.7973C47.1389 84.1892 49.4216 85.8009 51.8287 85.3764L64.245 83.1871L66.4343 95.6034C66.8561 97.9953 69.1388 99.607 71.5459 99.1826L76.0408 98.39C78.4327 97.9682 80.0444 95.6855 79.6199 93.2784L77.4306 80.8621L89.8469 78.6728C92.2388 78.251 93.8505 75.9683 93.4261 73.5612L92.6335 69.0664C92.2117 66.6744 89.929 65.0628 87.5219 65.4872Z",
    stroke: "white",
    strokeWidth: 5.04752,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_228_285",
    x: 10.8459,
    y: 15.7528,
    width: 113.934,
    height: 131.261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.63094
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26188
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_228_285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_228_285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_228_285",
    x: 25.5567,
    y: 31.2255,
    width: 55.3569,
    height: 100.007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.455318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.910635
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_228_285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_228_285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_228_285",
    x: 60.3001,
    y: 31.177,
    width: 50.6037,
    height: 99.9382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.455318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.910635
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_228_285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_228_285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_228_285",
    x: 40.8088,
    y: 47.1962,
    width: 57.7331,
    height: 57.7332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.63094
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26188
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_228_285"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_228_285",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117.357,
    height: 141.331,
    fill: "white",
    transform: "translate(0.381836 21.26) rotate(-9.99999)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg040202);
export default __webpack_public_path__ + "static/media/img_04_02_02.27de6028cb4a342730045013be02bd26.svg";
export { ForwardRef as ReactComponent };